import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CFormSelect,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
} from '@coreui/react-pro'
import PlayerService from 'src/service/PlayerService'
const RoundPlayerStatsTab = (props) => {
  const [statsData, setStatsData] = useState([])
  const handlePlayer = (e) => {
    const playerId = e.target.value
    PlayerService.playerStatsByRound(playerId).then((res) => {
      if (res.success) {
        setStatsData(res.data)
      }
    })
  }
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CFormSelect
              aria-label="Select player"
              name="player"
              className={'form-control'}
              onChange={handlePlayer}
              id="player"
            >
              <option value={0}>Select Player</option>
              {props.playerList &&
                props.playerList.map((item, key) => (
                  <option value={item?.id} key={key}>
                    {item?.full_name}
                  </option>
                ))}
            </CFormSelect>
            <CTable className="main-table table innertable">
              <CTableHead color="dark">
                <tr>
                  <th>RD</th>
                  <th>FP</th>
                  <th>POS</th>
                  <th>GO</th>
                  <th>GKS</th>
                  <th>OG </th>
                  <th>AST</th>
                  <th>PI</th>
                  <th>PW</th>
                  <th>PS</th>
                  <th>PM</th>
                  <th>GCD</th>
                  <th>YCD</th>
                  <th>RCD</th>
                  <th>CST</th>
                  <th>P60</th>
                  <th>P60PLUS</th>
                </tr>
              </CTableHead>
              <CTableBody>
                {statsData &&
                  statsData.map((item, key) => (
                    <tr key={key}>
                      <td>
                        <strong> {item.round}</strong>
                      </td>
                      <td>{item.sum_fp}</td>
                      <td>{item.position_name}</td>
                      <td>{item?.sum_go}</td>
                      <td>{item?.sum_gks}</td>
                      <td>{item?.sum_og}</td>
                      <td>{item?.sum_ast}</td>
                      <td>{item?.sum_pi}</td>
                      <td>{item?.sum_tw}</td>
                      <td>{item?.sum_ps}</td>
                      <td>{item?.sum_pm}</td>
                      <td>{item?.sum_gcd}</td>
                      <td>{item?.sum_ycd}</td>
                      <td>{item?.sum_rcd}</td>
                      <td>{item?.sum_cst}</td>
                      <td>{item?.sum_p60}</td>
                      <td>{item?.sum_p60plus}</td>
                    </tr>
                  ))}
                {statsData.length === 0 && (
                  <tr>
                    <td colSpan={15}>No record yet available.</td>
                  </tr>
                )}
              </CTableBody>
            </CTable>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default RoundPlayerStatsTab
